__turbopack_context__.v({
  "buttonContainer": "AboutUsTextAndCarousel-module__DNnW9q__buttonContainer",
  "carouselButton": "AboutUsTextAndCarousel-module__DNnW9q__carouselButton",
  "carouselButtonContainer": "AboutUsTextAndCarousel-module__DNnW9q__carouselButtonContainer",
  "carouselButtonNext": "AboutUsTextAndCarousel-module__DNnW9q__carouselButtonNext",
  "carouselButtonPrevious": "AboutUsTextAndCarousel-module__DNnW9q__carouselButtonPrevious",
  "carouselContainer": "AboutUsTextAndCarousel-module__DNnW9q__carouselContainer",
  "carouselItem": "AboutUsTextAndCarousel-module__DNnW9q__carouselItem",
  "carouselItemText": "AboutUsTextAndCarousel-module__DNnW9q__carouselItemText",
  "carouselScrollContainer": "AboutUsTextAndCarousel-module__DNnW9q__carouselScrollContainer",
  "carouselTrack": "AboutUsTextAndCarousel-module__DNnW9q__carouselTrack",
  "container": "AboutUsTextAndCarousel-module__DNnW9q__container",
  "pip": "AboutUsTextAndCarousel-module__DNnW9q__pip",
  "pipContainer": "AboutUsTextAndCarousel-module__DNnW9q__pipContainer",
  "pipSelected": "AboutUsTextAndCarousel-module__DNnW9q__pipSelected",
});
